export default function hasEmoji(string) {
  const emojiRegex = /\p{Extended_Pictographic}/u;
  return emojiRegex.test(string);
}
